module.exports = __webpack_public_path__ + "static/media/TCS.c7c41819.txt";